

export const AUTH_ERROR_CODES = {

  E001: { code: 'E001', message: '账号已存在' },
  E002: { code: 'E002', message: '邮箱已被注册' },
  E003: { code: 'E003', message: '推荐码无效' },
  E004: { code: 'E004', message: '请重新注册' },
  E005: { code: 'E005', message: '验证码错误' },
  E006: { code: 'E006', message: '已绑定过邀请码' },
  E007: { code: 'E007', message: '不能绑定自己' },

  E011: { code: 'E011', message: '邮箱或密码错误' },
  E012: { code: 'E012', message: '账号已被锁定' },
  E013: { code: 'E013', message: '请重新登录' },
  E014: { code: 'E014', message: '账号不可用' },
  E015: { code: 'E015', message: '验证码错误' },
  E016: { code: 'E016', message: 'Telegram 登录失败' },
  E017: { code: 'E017', message: 'Telegram 登录失败' },
  E018: { code: 'E018', message: 'Google 登录失败' },
  E019: { code: 'E019', message: 'Google 登录失败' },

  E021: { code: 'E021', message: '当前密码错误' },
  E022: { code: 'E022', message: '新旧密码相同' },
  E023: { code: 'E023', message: '该邮箱未注册' },
  E024: { code: 'E024', message: '账号已被禁用' },
  E025: { code: 'E025', message: '请重新申请' },
  E026: { code: 'E026', message: '验证码已过期' },
  E027: { code: 'E027', message: '验证码错误' },
  E028: { code: 'E028', message: '用户不存在' },
  E029: { code: 'E029', message: '请填写要改的内容' },

  E031: { code: 'E031', message: '请求已失效' },
  E032: { code: 'E032', message: 'API Key 不存在' },
  E033: { code: 'E033', message: 'API Key 已禁用' },
  E034: { code: 'E034', message: '账号已禁用' },
  E035: { code: 'E035', message: '签名无效' },
  E036: { code: 'E036', message: '最多 5 个 API Key' },
  E037: { code: 'E037', message: 'API Key 无效' },
  E038: { code: 'E038', message: 'API Key 不存在' },

  E041: { code: 'E041', message: '发送过于频繁' },
  E042: { code: 'E042', message: '验证码已过期' },
  E043: { code: 'E043', message: '验证码错误' },
  E044: { code: 'E044', message: '邮箱已验证' },
  E045: { code: 'E045', message: '邮箱已被占用' },
  E046: { code: 'E046', message: '请先验证邮箱' },
  E047: { code: 'E047', message: '请先发送验证码' },
  E048: { code: 'E048', message: '请先验证当前邮箱' },
  E049: { code: 'E049', message: '请先发送验证码' },
  E050: { code: 'E050', message: '操作无效' },
  E051: { code: 'E051', message: '验证过于频繁' },
  E052: { code: 'E052', message: '请先验证邮箱' },
  E053: { code: 'E053', message: '邮箱不匹配' },
  E054: { code: 'E054', message: '验证码已过期' },
  E055: { code: 'E055', message: '验证数据不符' },

  E061: { code: 'E061', message: '权限不足' },
  E062: { code: 'E062', message: '用户不存在' },
  E063: { code: 'E063', message: '角色不存在' },
  E064: { code: 'E064', message: '角色使用中，不可删' },
  E065: { code: 'E065', message: '系统角色不可改' },
  E066: { code: 'E066', message: '状态值无效' },
  E067: { code: 'E067', message: '仅限查看团队成员' },

  E071: { code: 'E071', message: '会话不存在' },
  E072: { code: 'E072', message: '不能撤销当前会话' },
  E073: { code: 'E073', message: '会话已撤销' },

  E081: { code: 'E081', message: '配置参数无效' },
  E082: { code: 'E082', message: '连接测试失败' },
  E083: { code: 'E083', message: '密钥处理失败' },
  // @deprecated credit 全面化后后端不产生 E084,留兜底兼容老错误
  E084: { code: 'E084', message: 'Credit 余额不足' },
  E085: { code: 'E085', message: '服务已禁用' },
  E086: { code: 'E086', message: '平台 Key 未配置' },
  E087: { code: 'E087', message: '名称已被占用' },

  E091: { code: 'E091', message: '请求参数有误' },
  E092: { code: 'E092', message: '操作过于频繁' },
  E093: { code: 'E093', message: '请重新登录' },
  E094: { code: 'E094', message: '登录已过期' },
  E095: { code: 'E095', message: '登录已失效' },
  E096: { code: 'E096', message: '服务繁忙' },
  E097: { code: 'E097', message: '资源不存在' },
  E098: { code: 'E098', message: '资源冲突' },

  E101: { code: 'E101', message: '手机号格式错误' },
  E102: { code: 'E102', message: '手机号已注册' },
  E103: { code: 'E103', message: '该手机号未注册' },
  E104: { code: 'E104', message: '短信发送失败' },
  E105: { code: 'E105', message: '发送过于频繁' },
  E106: { code: 'E106', message: '验证码错误' },
  E107: { code: 'E107', message: '验证码已过期' },

  E108: { code: 'E108', message: '团队不存在' },
  E109: { code: 'E109', message: '请重新登录' },

  E110: { code: 'E110', message: '团队标识已被占用' },
  E111: { code: 'E111', message: '成员不存在' },
  E112: { code: 'E112', message: '权限不足' },
  E113: { code: 'E113', message: '请先转让所有权' },
  E114: { code: 'E114', message: '请先清理团队资源' },
  E115: { code: 'E115', message: '邀请已失效' },
  E116: { code: 'E116', message: '邀请已过期' },
  E117: { code: 'E117', message: '团队未配置该服务' },
  E118: { code: 'E118', message: '你不是团队成员' },
  E119: { code: 'E119', message: '团队名称无效' },
  E120: { code: 'E120', message: '转让目标无效' },
  E121: { code: 'E121', message: '角色无效' },

  E122: { code: 'E122', message: 'Credit 余额不足' },

  E123: { code: 'E123', message: '该用户已是员工' },
  E124: { code: 'E124', message: '邀请码无效' },
  E125: { code: 'E125', message: '邀请码已过期' },
  E126: { code: 'E126', message: '邀请码次数已用尽' },
  E127: { code: 'E127', message: '无租户访问权限' },

  E130: { code: 'E130', message: '调动记录不存在' },
  E131: { code: 'E131', message: '调动已完成' },
  E132: { code: 'E132', message: '离职申请不存在' },
  E133: { code: 'E133', message: '离职已处理' },
  E134: { code: 'E134', message: '管理员不可离职' },

  E140: { code: 'E140', message: '审批模板不存在' },
  E141: { code: 'E141', message: '模板编码已存在' },
  E142: { code: 'E142', message: '审批模板已禁用' },
  E143: { code: 'E143', message: '审批实例不存在' },
  E144: { code: 'E144', message: '审批已结束' },
  E145: { code: 'E145', message: '非当前审批人' },
  E146: { code: 'E146', message: '审批已取消' },
  E147: { code: 'E147', message: '无法取消审批' },
  E148: { code: 'E148', message: '找不到审批人' },
  E149: { code: 'E149', message: '已操作过此节点' },

  E156: { code: 'E156', message: '班次不存在' },
  E157: { code: 'E157', message: '班次编码已存在' },
  E158: { code: 'E158', message: '排班不存在' },
  E159: { code: 'E159', message: '今日已签到' },
  E160: { code: 'E160', message: '尚未签到' },
  E161: { code: 'E161', message: '今日已签退' },
  E162: { code: 'E162', message: '日期范围无效' },

  E170: { code: 'E170', message: '公告不存在' },
  E171: { code: 'E171', message: '消息不存在' },
  E172: { code: 'E172', message: '已标记已读' },

  E175: { code: 'E175', message: '考勤组不存在' },
  E176: { code: 'E176', message: '考勤组编码已存在' },
  E177: { code: 'E177', message: '员工不在任何考勤组' },
  E178: { code: 'E178', message: '不在打卡时间内' },
  E179: { code: 'E179', message: '打卡地点超出范围' },
  E180: { code: 'E180', message: 'WiFi 不在允许范围' },
  E181: { code: 'E181', message: '补卡申请不存在' },
  E182: { code: 'E182', message: '该日期已有补卡' },
  E183: { code: 'E183', message: '补卡日期无效' },
  E184: { code: 'E184', message: '无主打卡记录' },
  E185: { code: 'E185', message: '当前打卡对未完成' },
  E186: { code: 'E186', message: '员工已在其他考勤组' },
  E187: { code: 'E187', message: '考勤组已停用' },
  E188: { code: 'E188', message: '弹性配置必填' },
  E189: { code: 'E189', message: '非工作日' },
} as const;

export type ErrorCode = keyof typeof AUTH_ERROR_CODES;

export function getErrorMessage(code: string): string {
  const error = AUTH_ERROR_CODES[code as ErrorCode];
  return error?.message || '未知错误';
}

export function isTokenExpiredError(code: string): boolean {
  return code === 'E094';
}

export function isAuthError(code: string): boolean {
  return ['E093', 'E094', 'E095'].includes(code);
}

function formatRateLimitMessage(
  baseMessage: string | undefined,
  details: any,
): string | undefined {
  const wait = details?.waitSeconds;
  if (typeof wait === 'number' && wait > 0) {
    return `请稍候 ${wait} 秒再试`;
  }
  return baseMessage;
}

export function extractErrorMessage(error: any, defaultMessage: string = '请求失败'): string {

  if (error?.response?.data) {
    const data = error.response.data;
    const code = data.error?.code;

    if (code === 'E092') {
      const enhanced = formatRateLimitMessage(data.message, data.error?.details);
      if (enhanced) return enhanced;
    }
    if (data.message) {
      return data.message;
    }
    if (code) {
      return getErrorMessage(code);
    }
  }

  if (error?.info) {
    const code = error.info.errorCode;

    if (code === 'E092') {
      const enhanced = formatRateLimitMessage(
        error.info.errorMessage,
        error.info.data?.error?.details,
      );
      if (enhanced) return enhanced;
    }
    if (error.info.errorMessage) {
      return error.info.errorMessage;
    }
    if (code) {
      const msg = getErrorMessage(code);
      if (msg !== '未知错误') return msg;
    }
  }

  return defaultMessage;
}

export function getApiLanguage(locale: string): 'zh' | 'en' | undefined {
  if (locale === 'zh-CN') {
    return undefined;
  }
  return 'en';
}

export function isKnownAuthErrorCode(code: string | undefined | null): boolean {
  return !!code && Object.prototype.hasOwnProperty.call(AUTH_ERROR_CODES, code);
}
